import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import faTranslation from '../locales/fa/translation.json';
import enTranslation from '../locales/en/translation.json';
import { detectLanguageFromPath } from './pathDetector';

const resources = {
  fa: {
    translation: faTranslation,
  },
  en: {
    translation: enTranslation,
  },
};

// Initialize with path-based language detection
const initialLanguage = detectLanguageFromPath();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,
    fallbackLng: 'fa',
    supportedLngs: ['fa', 'en'],
    defaultNS: 'translation',
    ns: ['translation'],
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    detection: {
      // Custom path detector
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;

